import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { timeout,catchError } from 'rxjs/operators';
import { AccountService } from '../account.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private accountService: AccountService) {}
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        return next.handle(request).pipe(
            timeout(10000),
            catchError(err => {
            const isBackground = request.headers.has('X-Background-Request');
            if (err.status === 401 && !isBackground) {
                this.accountService.logout();
            }
            return throwError(err);
        }))
    }
}


